module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hres88e"
    }
  }, [_c('hrms-search-box-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp),
      expression: "indexDisp"
    }],
    attrs: {
      "data": _vm.index,
      "nowLang": _vm.app.nowLang,
      "columns": _vm.columns[_vm.app.nowLang].index,
      "unLoadBool": true,
      "receivedStore": _vm.receivedHres88eIndex,
      "addEvent": _vm.addEvent,
      "editEvent": _vm.editEvent,
      "cancelEvent": _vm.cancelEvent,
      "searchBoxAlias": "hres88e"
    },
    model: {
      value: (_vm.searchIndex),
      callback: function($$v) {
        _vm.searchIndex = $$v
      },
      expression: "searchIndex"
    }
  }), _vm._v(" "), _c('detail', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailDisp),
      expression: "detailDisp"
    }],
    attrs: {
      "labels": _vm.labels[_vm.app.nowLang],
      "labelsButton": _vm.app.button[_vm.app.nowLang],
      "nowLang": _vm.app.nowLang,
      "toggle": _vm.toggle,
      "indexSelected": _vm.indexSelected,
      "codempid": _vm.codempid,
      "descCodempid": _vm.app.currentUser.username[_vm.app.nowLang],
      "detail": _vm.detail,
      "currentDtereq": _vm.currentDtereq,
      "currentNumseq": _vm.detail.numseq,
      "dropdowns": _vm.dropdowns,
      "searchIndex": _vm.searchIndex,
      "descCodapp": _vm.dash.descCodapp,
      "listFields": _vm.listFields,
      "eventBtn": _vm.eventBtn,
      "postHres88eDetailSave": _vm.postHres88eDetailSave,
      "receivedHres88eDetailCodjob": _vm.receivedHres88eDetailCodjob
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c3e02f4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres88e/component.vue
// module id = 3543
// module chunks = 1